/* eslint-disable no-unused-vars */
import axios from "@/axios.js";

export default {
  fetchAudiences({ commit }, param) {
    return new Promise((resolve, reject) => {
      axios
        .get("/question/audiences", { params: param })
        .then((response) => {
          const data = response.data.data;
          commit("SET_AUDIENCES", data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchCatalogues({ commit }, param) {
    return new Promise((resolve, reject) => {
      axios
        .get("/question/catalogues", { params: param })
        .then((response) => {
          const data = response.data.data;
          commit("SET_CATALOGUES", data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchQuestions({ commit }, param) {
    return new Promise((resolve, reject) => {
      axios
        .get("/question/qna", { params: param })
        .then((response) => {
          const data = response.data.data;
          commit("SET_QUESTIONS", data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  setPaginationAudiences({ commit }, page) {
    commit("SET_PAGINATION_AUDIENCES", page);
  },
  setPaginationCatalogues({ commit }, page) {
    commit("SET_PAGINATION_CATALOGUES", page);
  },
  setPaginationQuestions({ commit }, page) {
    commit("SET_PAGINATION_QUESTIONS", page);
  },
  setCurrentPageQuestions({ commit }, data) {
    commit("SET_CURRENT_PAGE_QUESTIONS", data);
  },
  setPerPageQuestions({ commit }, perPage) {
    commit("SET_PER_PAGE_QUESTIONS", perPage);
  },
  deleteQuestion({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/question/qna/${id}`)
        .then((response) => {
          commit("REMOVE_RECORD_QUESTIONS", id);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async createQuestion({ commit }, payload) {
    return await axios.post(`/question/qna`, payload);
  },
  async updateQuestion({ commit }, { id, payload }) {
    return await axios.put(`/question/qna/${id}`, payload);
  },
  async createCatalogue({ commit }, payload) {
    return await axios.post(`/question/catalogues`, payload);
  },
  async updateCatalogue({ commit }, { id, payload }) {
    return await axios.put(`/question/catalogues/${id}`, payload);
  },
  async deleteCatalogue({ commit }, id) {
    return await axios.delete(`/question/catalogues/${id}`);
  },
};
